var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvisions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.c{fill-rule:evenodd;}.b,.c{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.923,8a1,1,0,0,1,.914,1.406l-2.847,6.406A2,2,0,0,1,12.162,17h-7.4a2,2,0,0,1-1.828-1.188L.086,9.406A1,1,0,0,1,1,8ZM4.089,10H3.961a.372.372,0,0,0-.371.4l.014.074,1.249,4.165a.5.5,0,0,0,.4.35L5.334,15h.128a.372.372,0,0,0,.371-.4l-.014-.074L4.568,10.356A.5.5,0,0,0,4.089,10Zm4.372,0a.5.5,0,0,0-.492.41l-.008.09v4a.5.5,0,0,0,.992.09l.008-.09v-4A.5.5,0,0,0,8.461,10Zm4.5,0h-.128a.5.5,0,0,0-.479.356h0l-1.249,4.165a.372.372,0,0,0,.356.479h.128a.5.5,0,0,0,.479-.356h0l1.249-4.165A.372.372,0,0,0,12.961,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.461,18h6a.5.5,0,0,1,0,1h-6a.5.5,0,0,1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.461,1h1l-5,7h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.461,1h1l5,7h-1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(7.461)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvisions);
export default __webpack_public_path__ + "static/media/provisions.bf1ffd299212fd775428f48bc25d8aba.svg";
export { ForwardRef as ReactComponent };